import * as React from 'react';
import * as Models from '../../../models/index';
import * as Components from '../../../components/index';

export interface MessageDetailsProps {
	message: Models.CorporateMessage;
}
const MessageDetails: React.StatelessComponent<MessageDetailsProps> = props => (
	<Components.LayoutBlock fill className='message-details'>
		<Components.LayoutBlock className='message-details-header' inline>
			<Components.Label>{props.message.subject}</Components.Label>
		</Components.LayoutBlock>
		<Components.LayoutBlock className='message-details-body' scrollable fill>
			<section dangerouslySetInnerHTML={{ __html: props.message.body }} />
		</Components.LayoutBlock>
	</Components.LayoutBlock>
);

export default MessageDetails;
